<template>
    <div class="card">
        <div class="pos-tabs">
            <div
                v-for="tab in tabs"
                :key="tab.key"
                class="pos-tab-card"
                :class="[tab.key, { active: activeTab === tab.key }]"
                @click="setActiveTab(tab.key)"
            >
                {{ tab.label }}
            </div>
        </div>

        <ItemCard v-if="activeTab === 'pos' && !loader" 
            :parentGroup="parentGroup"
            :contactProfileId="contactProfileId"
            :companyId="companyId"
            :productId="productId"
        />

        <BillList v-if="activeTab === 'bill'"/>
    </div>
</template>

<script setup>
    import ItemCard from '@/components/molecule/company/sdm/pos-invoice/PosBilling.vue';
    import BillList from '@/components/molecule/company/sdm/pos-invoice/PosInvoiceList.vue';
    import handleInventory from '@/services/modules/inventory';
    import { onMounted, ref, computed } from 'vue';
    import {useRoute, useRouter} from 'vue-router';
    import { useStore } from 'vuex';

    const $route = useRoute();
    const $router = useRouter();
    const $store = useStore();

    const loader = ref(true);
    const contactProfileId = ref(null);
    const companyId = $route.params.companyId
    const companyQuery = `?company_id=${companyId}`;
    const productId = ref(null);
    const activeTab = ref('pos');

    const parentGroup = ref([]);

    const { fetchGroupParent } = handleInventory();

    const tabs = [
        { key: 'pos', label: 'POS Billing' },
        { key: 'bill', label: 'Bill List' },
    ]

    onMounted(async ()=>{
        if ($route.query.selected_tab === 'bill') {
            activeTab.value = 'bill';
        }

        loader.value = true;
        await getProductHeadGroup(true);
        loader.value = false;
    })

    const setActiveTab = (key) => {
        activeTab.value = key;
        $router.replace({
            query: {
                ...$route.query,
                redirect_route: 'pos-invoice',
                selected_tab: key,
            },
        });
    }

    const getProductHeadGroup = async () => {
        const query = `?company_id=${companyId}&product_type=finished_goods,services`;

        try{
            const { data } = await fetchGroupParent(query);
            if(data.length == 0){
                return
            }
            parentGroup.value = data;
        }catch(e){
            console.log("Something went wrong");
        }
    }
</script>

<style scoped>
.font-24 {
    font-size: 24px;
}

.pos-tab {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-weight: 500;
    cursor: pointer;
    background: #f5f5f5;
    transition: all 0.2s ease;
}

.pos-tab:last-child {
    border-right: none;
}

.pos-tab.active {
    font-size: 20px;
    font-weight: 700;
    background: #cfe2ff; /* active blue */
}

.pos-tab:not(.active):hover {
    background: #e9ecef;
}

.pos-tabs {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 15px;
    padding: 10px;
}

/* BASE CARD */
.pos-tab-card {
    display: flex;        
    align-items: center;    
    justify-content: center;

    padding: 14px 10px;
    border-radius: 12px;
    text-align: center;
    font-weight: 600;
    cursor: pointer;

    color: #fff;
    box-shadow: 0 4px 10px rgba(0,0,0,0.12);
    transition: all 0.2s ease;
}

/* ACTIVE */
.pos-tab-card.active {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
    font-size: 24px;
}

/* HOVER */
.pos-tab-card:hover {
    transform: translateY(-1px);
}

/* POS Billing → Primary */
.pos-tab-card.pos {
    background: linear-gradient(135deg, #7367f0, #9e95f5);
}

/* Bill List → Success */
.pos-tab-card.bill {
    background: linear-gradient(135deg, #28c76f, #55dd92);
}

/* Order List → Warning */
.pos-tab-card.order {
    background: linear-gradient(135deg, #ff9f43, #ffc085);
}

/* Customer List → Danger */
.pos-tab-card.customer {
    background: linear-gradient(135deg, #ea5455, #f08182);
}

</style>